<template>
	<div class="list-item create-customer">
		<meta property="og:title" content="你好">
		<van-form validate-first label-width="95">
			<van-field class="color" v-model="form.customerName" name="姓名" label="姓名" placeholder="请输入姓名" maxlength="20"
				:rules="[{ required: true }]" :disabled="disabled"/>
			<van-field class="color" v-model="form.addressDesc" name="地区" label="地区" placeholder="请选择地区" readonly
				:rules="[{ required: true }]" @click="changeAddress" :disabled="disabled"></van-field>
			<van-field class="color" v-model="form.customerAge" name="年龄" label="年龄" placeholder="请输入年龄"
				:rules="[{ required: true }]" :disabled="disabled"/>
			<van-field class="color" v-model="form.customerTel" name="电话" label="电话" placeholder="请输入电话"
				:rules="[{ pattern: telPattern, message: '请输入正确的手机号' }]" :disabled="disabled"/>
			<van-field v-model="form.customerIdCard" name="身份证" label="身份证号" placeholder="请输入身份证号" :disabled="disabled"/>
			<van-field v-model="form.wechatNum" name="微信" label="微信号" placeholder="请输入微信号" :disabled="disabled"/>
			<van-field v-model="form.tiktokNum" name="抖音" label="抖音号" placeholder="请输入抖音号(多个以逗号隔开)" :disabled="disabled"/>
			<van-field class="color" v-model="form.customerPosition" name="职务" label="职务" placeholder="请输入职务"
				:rules="[{ required: true }]" :disabled="disabled"/>
			<van-field class="color" readonly clickable name="创办时间" v-model="form.schoolFoundingTime" label="学校创办时间"
				placeholder="点击选择时间" @click="showpicker" :rules="[{ required: true }]" :disabled="disabled"/>
			<van-field class="color" v-model="form.orgArea" name="面积" label="机构面积" placeholder="请输入机构面积"
				:rules="[{ required: true }]" :disabled="disabled"/>
			<van-field class="color" v-model="form.orgStudentNum" name="数量" label="机构学生数量" placeholder="请输入机构学生数量"
				:rules="[{ required: true }]" :disabled="disabled"/>
			<van-field class="color" v-model="form.institutionalTeachersNum" name="老师数量" label="机构老师数量"
				placeholder="请输入机构老师数量" :rules="[{ required: true }]" :disabled="disabled"/>
			<van-field class="color" v-model="form.shareholderNum" name="股东人数" label="股东人数" placeholder="请输入股东人数"
				:rules="[{ required: true }]" :disabled="disabled"/>
			<!-- <van-field v-model="form.schoolFoundingTime" name="创办时间" label="学校创办时间" placeholder="请选择学校创办时间" :rules="[{ required: true }]" /> -->

			<van-field class="color" name="discipType" label="学科类型" :disabled="disabled">
				<template #input>
					<van-checkbox-group v-model="form.subjectType" direction="horizontal">
						<van-checkbox v-for="item in subject" :key="item.id" :name="item.id" shape="round" >
							{{ item.name }}
						</van-checkbox>
					</van-checkbox-group>
				</template>
			</van-field>
			<van-field class="color" name="schoolProblem" label="学校问题" :disabled="disabled">
				<template #input>
					<van-checkbox-group v-model="form.schoolQuestion" direction="horizontal">
						<van-checkbox v-for="item in school" :key="item.id" :name="item.id" shape="round">
							{{ item.name }}
						</van-checkbox>
					</van-checkbox-group>
				</template>
			</van-field>
			<div class="region-list">
				<p class="border-bottom">机构地址</p>
				<van-field name="org" :disabled="disabled">
					<template #input>
						<ul class="list">
							<li class="border-bottom region-item" v-for="(item, index) in org" :key="index"
								@click="modifyRegion('edit', item, index)">
								<van-icon color="#169BD5" name="edit" />
								<span>{{ item.orgName }}</span>
							</li>
							<li class="add border-bottom" @click="modifyRegion('add')">
								<van-icon name="add-o" color="#008000" />
								<span style="float: right;">添加机构</span>
							</li>
						</ul>
					</template>
				</van-field>
			</div>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit" @click="submit()" :disabled="disabled">提交</van-button>
			</div>
		</van-form>
		<van-popup v-model="show" position="bottom">
			<van-area title="选择地区" :value="form.cityId" :area-list="areaList" :columns-num="2" @confirm="complete"
				@cancel="cancel" />
		</van-popup>
		<Region v-if="showRegion" :value="currentRegion" :visible.sync="showRegion" @saveRegion="handleRegion" />
		<van-popup v-model="showPicker" position="bottom">
			<van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
				@confirm="foundingTime" @cancel="showPicker = false" />
		</van-popup>
	</div>
</template>

<script>
	import {
		areaList
	} from '@vant/area-data';
	import {
		telRegExp
	} from '@/utils';
	import {
		getCustomerRegionList,
		getCustomerCollectDetail,
		getCustomerCollectLable,
		createCustomerRegion,
		updateCustomerRegion,
		getCustomerCollectCreate,
		Acquisitionverification
	} from '@/api/customer.js';
	import Region from '@/components/region';


	export default {
		name: 'proResrarch',
		components: {
			Region
		},
		data() {
			return {
				disabled:false,
				telPattern: telRegExp,
				form: {
					customerName: '',
					customerTel: '',
					customerAge: '',
					cityId: '',
					provinceId: '',
					customerIdCard: '',
					wechatNum: '',
					tiktokNum: '',
					customerPosition: '',
					shareholderNum: '',
					schoolFoundingTime: '',
					institutionalTeachersNum: '',
					orgArea: '',
					orgStudentNum: '',
					customerId: '',
					schoolQuestion: [],
					subjectType: []
				},
				org: [], // 机构
				address: '',
				areaList: areaList,
				show: false,
				subject: [],
				school: [],
				modifyRegionIndex: null,
				showRegion: false,
				showPicker: false,
				minDate: new Date(1990, 0, 1),
				maxDate: new Date(),
				currentDate: new Date(2000, 0, 1)
			};
		},
		created() {
			if(!this.$route.query.captchaId || !this.$route.query.customerId){
				this.$toast('地址有误，请联系管理员');
				this.disabled = true
				return false
			}

			Acquisitionverification({captchaId:this.$route.query.captchaId}).then(res => {
				if(res.data === false) {
					return alert('非法操作：授权码无效或过期！')
				}
				this.getCustomerCollectDetail()
				this.getCustomerRegionList()
			});
			
			
			
		},
		mounted() {
		
		},
		methods: {
			getCustomerCollectDetail() {
				if (this.$route.query) {
					this.form.customerId = Number(this.$route.query.customerId);
				} else {
					this.form.customerId = this.$utils.getUrlKey('customerId');
				}
				getCustomerCollectDetail({
					customerId: this.form.customerId
				}).then(res => {
					if (res.errcode === 0) {
						this.form = res.data;
						this.form.cityId = res.data.cityId.toString();
					}
				});
				getCustomerCollectLable('type=7').then(res => {
					if (res.errcode === 0) {
						this.subject = res.data;
						this.subject.forEach(item => {
							item.id = item.id.toString();
						});
					}
				});
				getCustomerCollectLable('type=8').then(res => {
					if (res.errcode === 0) {
						this.school = res.data;
						this.school.forEach(item => {
							item.id = item.id.toString();
						});
					}
				});
			},
			getCustomerRegionList() {
				getCustomerRegionList({
					customerId: this.form.customerId,
					count: 100,
					page: 1
				}).then(res => {
					if (res.errcode === 0) {
						this.org = res.data;
					}
				});
			},

			changeAddress() {
				this.show = true;
			},
			handleRegion(val) {
				this.org = [];
				if (this.modifyRegionIndex !== null) {
					// 修改当前机构
					this.org.splice(this.modifyRegionIndex, 1, val);
					val.customerId = this.form.customerId;
					updateCustomerRegion(val).then(res => {
						if (res.errcode == 0) {
							this.getCustomerRegionList();
						}
					});
				} else {
					this.org.push(val);
					val.customerId = this.form.customerId;
					createCustomerRegion(val).then(res => {
						if (res.errcode == 0) {
							this.getCustomerRegionList();
						}
					});
				}
			},
			complete(e) {
				console.log(e);
				this.show = false;
				this.form.cityId = e[0].code;
				this.form.provinceId = e[1].code;
				this.form.addressDesc = e[0].name + ',' + e[1].name;
			},
			cancel() {
				this.show = false;
			},
			modifyRegion(type, item, index) {
				this.showRegion = true;
				if (type === 'add') {
					this.modifyRegionIndex = null;
					this.currentRegion = {};
				} else {
					this.currentRegion = item;
					this.modifyRegionIndex = index;
				}
			},
			showpicker() {
				this.showPicker = true;
			},
			foundingTime(date) {
				this.form.schoolFoundingTime = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
				console.log(this.form.schoolFoundingTime);
				this.showPicker = false;
			},
			submit() {
				if (this.form.customerName == '') {
					this.$toast('请输入姓名');
				} else if (this.form.addressDesc == '') {
					this.$toast('请选择地区');
				} else if (this.form.customerAge == '') {
					this.$toast('请输入年龄');
				} else if (this.form.customerTel == '') {
					this.$toast('请输入电话号码');
				} else if (this.form.orgStudentNum == '') {
					this.$toast('请输入机构学生数量');
				} else if (this.form.orgArea == '') {
					this.$toast('请输入机构面积');
				} else if (this.form.customerPosition == '') {
					this.$toast('请输入职务');
				} else if (this.form.shareholderNum == '') {
					this.$toast('请输入股东人数');
				} else if (this.form.schoolFoundingTime == '') {
					this.$toast('请输入学校创办时间');
				} else if (this.form.institutionalTeachersNum == '') {
					this.$toast('请输入机构老师数量');
				} else if (this.form.subjectType == []) {
					this.$toast('请选择学科类型');
				} else if (this.form.schoolQuestion == []) {
					this.$toast('请选择学校问题');
				} else {
					let poload = {
						customerId: Number(this.form.customerId),
						provinceId: Number(this.form.provinceId),
						cityId: Number(this.form.cityId),
						customerName: this.form.customerName,
						customerAge: Number(this.form.customerAge),
						customerTel: this.form.customerTel,
						customerIdCard: this.form.customerIdCard,
						wechatNum: this.form.wechatNum,
						tiktokNum: this.form.tiktokNum,
						orgStudentNum: Number(this.form.orgStudentNum),
						orgArea: Number(this.form.orgArea),
						subjectType: this.form.subjectType.join(','),
						schoolQuestion: this.form.schoolQuestion.join(','),
						customerPosition: this.form.customerPosition,
						shareholderNum: this.form.shareholderNum,
						schoolFoundingTime: this.form.schoolFoundingTime,
						institutionalTeachersNum: this.form.institutionalTeachersNum,
						captchaId:this.$route.query.captchaId
					};
					getCustomerCollectCreate(poload).then(res => {
						if (res.errcode == 0) {
							console.log('11');
							this.$router.push({
								path: '/finish'
							});
						}
					});
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.create-customer {
		background-color: #fff;
		overflow: auto;

		.region-list {
			margin: 0 16px;

			.van-field {
				padding: 0;
			}

			p {
				color: #646666;
				padding: 15px 0;
			}

			.list {
				width: 100%;

				li {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 10px 0;
				}

				.region-item {
					.van-icon-close {
						cursor: pointer;
						color: #ee0a24;
					}

					span {
						color: #646566;
					}
				}

				.add {
					.van-icon-add-o {
						color: rgba(128, 128, 128, 0.8);
						cursor: pointer;
					}

					span {
						color: rgba(128, 128, 128, 0.8);
					}
				}
			}
		}

		.footer {
			margin: 10px 0;
			text-align: center;
		}
	}

	/deep/.color {
		span::after {
			color: #ee0a24;
			font-size: 18px;
			content: '*';
		}
	}

	/deep/.van-checkbox__label::after {
		content: '' !important;
	}

	.van-field__label {
		font-size: 20px !important;
	}

	.create-customer {
		background-color: #fff;
		overflow: auto;

		.region-list {
			margin: 0 16px;

			.van-field {
				padding: 0;
			}

			p {
				color: #646666;
				padding: 15px 0;
			}

			.list {
				width: 100%;

				li {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 10px 0;
				}

				.region-item {
					.van-icon-close {
						cursor: pointer;
						color: #ee0a24;
					}

					span {
						color: #646566;
					}
				}

				.add {
					.van-icon-add-o {
						color: rgba(128, 128, 128, 0.8);
						cursor: pointer;
					}

					span {
						color: rgba(128, 128, 128, 0.8);
					}
				}
			}
		}

		.footer {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>
